"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MasterOnboardingStep = void 0;
/** Current step in the master onboarding flow. */
var MasterOnboardingStep;
(function (MasterOnboardingStep) {
    MasterOnboardingStep["BasicInfo"] = "basic-info";
    MasterOnboardingStep["ChessProfile"] = "chess-profile";
    MasterOnboardingStep["BioAndSections"] = "bio-and-sections";
    MasterOnboardingStep["SocialLinks"] = "social-links";
    MasterOnboardingStep["FeaturedVideos"] = "featured-videos";
    MasterOnboardingStep["Availability"] = "availability";
    MasterOnboardingStep["Completed"] = "completed-onboarding";
})(MasterOnboardingStep || (exports.MasterOnboardingStep = MasterOnboardingStep = {}));
